<template>
  <div>
    <TagSelector mainHeading="" optionName="teams" availableOptionsHeading="Available Workgroups' Teams"
      selectedOptionsHeading="User's workgroups' teams" :initial-skills="allTeams" v-model:interests="userTeams"
      @save-interests="handleSaveTeams" :loading="loading" :isSaving="submitting" />
  </div>
</template>

<script setup>
import { onMounted, ref, inject } from "vue";
import { useStore } from "vuex";
import TagSelector from "@/components/common/TagSelector.vue";
import { useRoute } from "vue-router";
import { getLocationId } from "../../../utils/SessionDataHandler";

const loading = ref(false);
const submitting = ref(false);

const props = defineProps({
  personId: { type: [Number, String], default: null },
  locationId: { type: [Number, String], default: null },
});

const store = useStore();
const route = useRoute();

// state
const allTeams = ref([]);
const userTeams = ref([]);

const _injectedPersonId = inject('editUserPersonId', null);
const personId = props.personId || _injectedPersonId?.value || Number(route.params.userid);
const locationId = props.locationId || getLocationId();

// --- Mapper ---
const mapTeams = (list) =>
  list.map((t) => ({
    id: t.teamid,
    name: t.teamname,
    description: `Members: ${t.teampersons_count ?? 0}`, // optional info
  }));

// fetch teams on mount
onMounted(async () => {
  loading.value = true;
  try {
    const res = await store.dispatch("fetchTeams", {
      locationId,
      personId,
    });

    allTeams.value = mapTeams(res.available_workgroup_teams ?? []);
    userTeams.value = mapTeams(res.persons_workgroup_teams ?? []);
  } finally {
    loading.value = false;
  }
});

// save teams
const handleSaveTeams = async (selected) => {
  submitting.value = true;
  try {
    await store.dispatch("saveTeams", {
      personId,
      locationId,
      teamsArray: selected.map((x) => x.id),
    });

    userTeams.value = selected; // keep UI in sync
  }
  finally {
    submitting.value = false;
  }
};
</script>
